import { flatten, uniq } from 'ramda';

import filterProcuredOffers from '../filterProcuredOffers';

const getOriginsFromProperties = (properties = []) => {
  const origins = filterProcuredOffers(properties).map(
    ({ procuredOffer }) => procuredOffer.origins,
  );

  return uniq(flatten(origins).sort());
};

export default getOriginsFromProperties;
